export const S3_CREATORS_REPORT_PREFIX = 'creatorsReport/';
export var CreatorsReportStatus;
(function (CreatorsReportStatus) {
    CreatorsReportStatus["DONE"] = "DONE";
    CreatorsReportStatus["IN_PROGRESS"] = "IN_PROGRESS";
    CreatorsReportStatus["ERROR"] = "ERROR";
})(CreatorsReportStatus || (CreatorsReportStatus = {}));
export var CreatorsReportFilter;
(function (CreatorsReportFilter) {
    CreatorsReportFilter["VerificationState"] = "verificationState";
    CreatorsReportFilter["DisplayName"] = "displayName";
    CreatorsReportFilter["Email"] = "email";
    CreatorsReportFilter["UserId"] = "userId";
})(CreatorsReportFilter || (CreatorsReportFilter = {}));
export const CREATORS_REPORT_COLUMNS = [
    {
        header: 'User ID',
        key: 'id',
    },
    {
        header: 'Channel url',
        key: 'channelUrl',
    },
    {
        header: 'Creator profile link',
        key: 'daredropProfileUrl',
    },
    {
        header: 'Email',
        key: 'email',
    },
    {
        header: 'Drops started',
        key: 'dropsStarted',
    },
    {
        header: 'Drops completed',
        key: 'dropsCompleted',
    },
    {
        header: 'Delivery rate',
        key: 'deliveryRate',
    },
    {
        header: '7 days CCV',
        key: 'ccv7',
    },
    {
        header: '14 days CCV',
        key: 'ccv14',
    },
    {
        header: '30 days CCV',
        key: 'ccv30',
    },
    {
        header: 'Languages',
        key: 'languages',
    },
    {
        header: 'Points Balance',
        key: 'pointsBalance',
    },
    {
        header: 'Points Total',
        key: 'pointsTotal',
    },
    {
        header: 'Last drop',
        key: 'lastDropUrl',
    },
    {
        header: 'Last joined to Drop',
        key: 'lastJoinedDropDate',
    },
    {
        header: 'Last activity',
        key: 'lastActionType',
        urlKey: 'lastActionProjectUrl',
    },
    {
        header: 'Last activity date',
        key: 'lastActionDate',
    },
    {
        header: 'Verification State',
        key: 'readableVerificationState',
    },
    {
        header: 'Content from last month',
        key: 'lastContentItemsCount',
    },
    {
        header: 'Last content date',
        key: 'lastContentDate',
    },
    {
        header: 'Created',
        key: 'created',
    },
];
